import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum RouletteZIndex {
  loadingPage = 999,
  kingBonusPop = 180,
  guidePage = 888,
  guideStepFooter = 900,
  footer = 100,
  scaleWheel = 3,
  resultPage = 200,
  orderResultPage = 199,
  floatScreen = 150,
}

export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}
export enum RouletteRoundStatusEnum {
  prepare = 1,
  bet = 2,
  drawPrize = 3,
  result = 4,
}
export enum RouletteColorEnum {
  红色 = 'r',
  绿色 = 'g',
  黑色 = 'b',
}
export enum RouletteBetTargetTypeEnum {
  fix_point = 1, // 固定点数
  point_range = 2, // 点数范围
  parity = 3, // 奇偶
  color = 4, // 颜色
}
export enum RouletteParityEnum {
  odd = 1, // 单数
  even = 0, // 双数
}

export enum subPageName {
  排行榜 = 'RankModal',
  规则页 = 'RulesModal',
  记录页 = 'RecordModal',
  获胜记录页 = 'WinRecordModal',
}

export enum RouletteSoundEnum {
  wheel = `${HostMaps.prod.img01}/download/file?obj=mefile/54/c2/618d-5ce4-11ee-b0ae-00163e0442bb` as any,
  zeroSecond = `${HostMaps.prod.img01}/download/file?obj=mefile/3a/98/3acd-5ce4-11ee-ae81-00163e04069f` as any,
  bet = `${HostMaps.prod.img01}/download/file?obj=mefile/49/63/036c-5ce4-11ee-b0ae-00163e0442bb` as any,
  clampChip = `${HostMaps.prod.img01}/download/file?obj=mefile/33/e4/ea1a-5ce4-11ee-ae81-00163e04069f` as any,
  win = `${HostMaps.prod.img01}/download/file?obj=mefile/3e/a2/f73f-5ce4-11ee-b0ae-00163e0442bb` as any,
  countDown = `${HostMaps.prod.img01}/download/file?obj=mefile/29/12/0b5f-5ce4-11ee-ae81-00163e04069f` as any,
}
export enum RouletteSoundTypeEnum {
  '转盘滚动' = 'wheel',
  '零秒' = 'zeroSecond',
  '下注' = 'bet',
  '收分筹码' = 'clampChip',
  '胜利' = 'win',
  '倒计时' = 'countDown',
}

export enum BetResultStatusEnum { // 下注结果
  notEnough = 2,
  success = 1,
}

export enum RouletteKingStateEnum {
  // 0:活动未开启 1:蓄力中 2:抢夺中;
  energy = 1,
  snatch = 2,
  none = 0,
}
